import loadScriptAsync from '../loadScriptAsync'
import debug from '../console'
import {
  markConsentTiming,
  measureConsentTiming,
} from '../consent/consentTiming'
import { ensureUsOptOutSignal } from '../consent/usOptOutSignal'
const logger = debug.withTag('utils:preAYScripts')

let pending: Promise<void> | null = null

const load = async () => {
  // This must precede the first LaunchPad request. The package wrapper makes
  // GPC/DNT authoritative in the CMP's __gpp/__uspapi responses before AY can
  // consume an allow-shaped vendor response.
  ensureUsOptOutSignal()
  markConsentTiming('cmp-request-start', true)
  /**
   * Launchpad carries the CMP, and LiveRamp is explicit that the CMP has to be up
   * before ATS and the consent-gated calls that depend on it, so this has to
   * settle before AY bootstraps.
   */
  await loadScriptAsync(
    'head',
    {
      src: `https://launchpad-wrapper.privacymanager.io/528606c5-a8ba-42f7-be55-93209da0477d/launchpad-liveramp.js`,
      key: 'liveramp',
    },
    { defer: true }
  ).catch((error) => {
    logger.warn(
      'Failed to load LiveRamp identity module, continuing without enhanced targeting',
      error
    )
  })
  markConsentTiming('cmp-request-settled', true)
  measureConsentTiming(
    'cmp-request',
    'cmp-request-start',
    'cmp-request-settled'
  )
}

/**
 * Memoized. Two plugins wait on this, and a second loadScriptAsync call for a
 * script that already failed attaches to the dead tag and never settles.
 */
export const preAYScripts = () => (pending ??= load())

export function resetPreAYScriptsForTests(): void {
  pending = null
}
